// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/search-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .navbar {
    height: 100px;
    margin: 0;
    padding: 0;
} */
.header {
    position: fixed !important;
    top: 0;
    right: 0;
    left: 0;
    /* z-index: 1030; */
    width: 100%;
    z-index: 1030;
    /* height: 160px; */
    /* transition: 0.3s; */
    background-color: #333;
    overflow:hidden;
}

.logo {
    /* width: 22%; */
    height: 100%;
    /* margin-top: 5px;
    margin-bottom: 10px; */
}
.logo img {
    /* margin-top: 15px; */
    height: 65px;
}
.hum-icon-div {
    position: absolute;
    right: -16px;
    height: 75px;
    width: 75px;
    background: #ff5800;
    text-align: center;
    /* top: -13px; */
}
/* .search-color {
    background: #eaeaea; 
     right: 0;
    top: 0; 
     position: fixed; 
     padding-left: 10px;
    padding-right: 10px;
} */
.searchbar-top {
    float: left;
    /* text-align: center; */
    /* margin: 7px; */
    background: #eaeaea;
    /* height: 75px; */
    width: 414px;
    margin-left: 498px;
    /* margin-top: 0px; */    
}
.searchbar-top input {
    height: 55px !important;
    width: 93% !important;
    border: none;
    text-align: left;
    padding: 20px 75px 20px 20px;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 300;
    background-color: #fff;
    margin: 10px 10px;
}
/* .navbar {
    padding: 0;
} */
.search-img {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: 87%;
}

.nav-items-container {
    flex: 1 1;
}

.nav-item {
    color: inherit;
}
@media (max-width: 1199.98px){
    .searchbar-top {
        margin-left: 154px;
        width: 410px;
    }
    .searchbar-top input{
        width: 93%;
    }
}

@media (max-width: 991.98px){
    .searchbar-top {
        margin-left: 61px !important;
        width: 415px
    }
}
@media (max-width: 767.98px) {
    .searchbar-top {
        /* margin-left: -77px !important;
        width: 117% !important; */
        display: none;
    }
    /* .searchbar-top input {            
     border: none;
        text-align: left;
        padding: 10px;
        font-size: 12px; 
    } */
    .hum-icon-div {            
        height: 101px;
        /* right: -60px; */
        top: -51px;
        width: 88px;
    }
    .header .navbar {
        height: 80px;
    }
    .logo img {
        height: 75px;
        padding: 7px;
    }
}

@media (max-width: 575.98px) {
    .searchbar-top {
        display: none;
    }
    .hum-icon-div {
        /* top: -24px; */
        height: 100px !important;
        right: -27px;
        width: 75px;
    }
    .logo img {
        height: 50px;
    }
}



`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/components/header.css"],"names":[],"mappings":"AAAA;;;;GAIG;AACH;IACI,0BAA0B;IAC1B,MAAM;IACN,QAAQ;IACR,OAAO;IACP,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;0BACsB;AAC1B;AACA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;;;;;;GAOG;AACH;IACI,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;;GAEG;AACH;IACI,mDAAiD;IACjD,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;AAClB;AACA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B;IACJ;AACJ;AACA;IACI;QACI;iCACyB;QACzB,aAAa;IACjB;IACA;;;;;OAKG;IACH;QACI,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,wBAAwB;QACxB,YAAY;QACZ,WAAW;IACf;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* .navbar {\n    height: 100px;\n    margin: 0;\n    padding: 0;\n} */\n.header {\n    position: fixed !important;\n    top: 0;\n    right: 0;\n    left: 0;\n    /* z-index: 1030; */\n    width: 100%;\n    z-index: 1030;\n    /* height: 160px; */\n    /* transition: 0.3s; */\n    background-color: #333;\n    overflow:hidden;\n}\n\n.logo {\n    /* width: 22%; */\n    height: 100%;\n    /* margin-top: 5px;\n    margin-bottom: 10px; */\n}\n.logo img {\n    /* margin-top: 15px; */\n    height: 65px;\n}\n.hum-icon-div {\n    position: absolute;\n    right: -16px;\n    height: 75px;\n    width: 75px;\n    background: #ff5800;\n    text-align: center;\n    /* top: -13px; */\n}\n/* .search-color {\n    background: #eaeaea; \n     right: 0;\n    top: 0; \n     position: fixed; \n     padding-left: 10px;\n    padding-right: 10px;\n} */\n.searchbar-top {\n    float: left;\n    /* text-align: center; */\n    /* margin: 7px; */\n    background: #eaeaea;\n    /* height: 75px; */\n    width: 414px;\n    margin-left: 498px;\n    /* margin-top: 0px; */    \n}\n.searchbar-top input {\n    height: 55px !important;\n    width: 93% !important;\n    border: none;\n    text-align: left;\n    padding: 20px 75px 20px 20px;\n    font-size: 16px;\n    text-transform: uppercase;\n    font-weight: 300;\n    background-color: #fff;\n    margin: 10px 10px;\n}\n/* .navbar {\n    padding: 0;\n} */\n.search-img {\n    background: url('../../../images/search-img.png');\n    background-repeat: no-repeat;\n    background-position: 87%;\n}\n\n.nav-items-container {\n    flex: 1;\n}\n\n.nav-item {\n    color: inherit;\n}\n@media (max-width: 1199.98px){\n    .searchbar-top {\n        margin-left: 154px;\n        width: 410px;\n    }\n    .searchbar-top input{\n        width: 93%;\n    }\n}\n\n@media (max-width: 991.98px){\n    .searchbar-top {\n        margin-left: 61px !important;\n        width: 415px\n    }\n}\n@media (max-width: 767.98px) {\n    .searchbar-top {\n        /* margin-left: -77px !important;\n        width: 117% !important; */\n        display: none;\n    }\n    /* .searchbar-top input {            \n     border: none;\n        text-align: left;\n        padding: 10px;\n        font-size: 12px; \n    } */\n    .hum-icon-div {            \n        height: 101px;\n        /* right: -60px; */\n        top: -51px;\n        width: 88px;\n    }\n    .header .navbar {\n        height: 80px;\n    }\n    .logo img {\n        height: 75px;\n        padding: 7px;\n    }\n}\n\n@media (max-width: 575.98px) {\n    .searchbar-top {\n        display: none;\n    }\n    .hum-icon-div {\n        /* top: -24px; */\n        height: 100px !important;\n        right: -27px;\n        width: 75px;\n    }\n    .logo img {\n        height: 50px;\n    }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
